import { Injectable } from '@angular/core';
import { ToastrService, ActiveToast } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CustomToastService {

  constructor(private toastr: ToastrService) {}

  success(message: string, title: string = 'Success') {
    this.toastr.show(
      `<div class="alert-content">
        <span class="alert-icon ni ni-bell-55" data-notify="icon"></span>
        <div class="alert-text">
          <span class="alert-title" data-notify="title">${title}</span>
          <span data-notify="message">${message}</span>
        </div>
      </div>`,
      '',
      {
        timeOut: 8000,
        closeButton: true,
        enableHtml: true,
        tapToDismiss: false,
        titleClass: 'alert-title',
        positionClass: 'toast-top-center',
        toastClass: 'ngx-toastr alert alert-dismissible alert-success alert-notify',
      }
    );
  }

  warning(message: string, title: string = 'Warning') {
    this.toastr.show(
      `<div class="alert-content">
        <span class="alert-icon ni ni-bell-55" data-notify="icon"></span>
        <div class="alert-text">
          <span class="alert-title" data-notify="title">${title}</span>
          <span data-notify="message">${message}</span>
        </div>
      </div>`,
      '',
      {
        timeOut: 8000,
        closeButton: true,
        enableHtml: true,
        tapToDismiss: false,
        titleClass: 'alert-title',
        positionClass: 'toast-top-center',
        toastClass: 'ngx-toastr alert alert-dismissible alert-warning alert-notify',
      }
    );
  }

  info(message: string, title: string = 'Info') {
    this.toastr.show(
      `<div class="alert-content">
        <span class="alert-icon ni ni-bell-55" data-notify="icon"></span>
        <div class="alert-text">
          <span class="alert-title" data-notify="title">${title}</span>
          <span data-notify="message">${message}</span>
        </div>
      </div>`,
      '',
      {
        timeOut: 8000,
        closeButton: true,
        enableHtml: true,
        tapToDismiss: false,
        titleClass: 'alert-title',
        positionClass: 'toast-top-center',
        toastClass: 'ngx-toastr alert alert-dismissible alert-info alert-notify',
      }
    );
  }

  error(message: string, title: string | null = null) {
    const titleHtml = title
      ? `<span class="alert-title d-block font-weight-bold">${title}</span>`
      : '';

    this.toastr.show(
      `<div class="alert-text w-100">
        ${titleHtml}
        <span data-notify="message">${message}</span>
      </div>`,
      '',
      {
        timeOut: 8000,
        closeButton: true,
        enableHtml: true,
        tapToDismiss: true,
        positionClass: 'toast-top-right',
        toastClass: 'ngx-toastr toast-error-custom',
      }
    );
  }

  errorCenter(message: string, title: string = 'Error') {
    this.toastr.show(
      `<div class="alert-content">
        <span class="alert-icon ni ni-bell-55" data-notify="icon"></span>
        <div class="alert-text">
          <span class="alert-title" data-notify="title">${title}</span>
          <span data-notify="message">${message}</span>
        </div>
      </div>`,
      '',
      {
        timeOut: 8000,
        closeButton: true,
        enableHtml: true,
        tapToDismiss: false,
        titleClass: 'alert-title',
        positionClass: 'toast-top-center',
        toastClass: 'ngx-toastr alert alert-dismissible alert-notify toast-error-center',
      }
    );
  }

  exporting(message: string, title: string = 'Exporting Overview'): ActiveToast<any> {
    return this.toastr.show(
      `<div class="alert-content">
        <span class="alert-icon" data-notify="icon">
          <img src="assets/img/brand/spinner.png" class="toast-spinner-img" />
        </span>
        <div class="alert-text">
          <span class="alert-title" data-notify="title">${title}</span>
          <span data-notify="message">${message}</span>
        </div>
      </div>`,
      '',
      {
        timeOut: 0,
        extendedTimeOut: 0,
        disableTimeOut: true,
        closeButton: true,
        enableHtml: true,
        tapToDismiss: false,
        titleClass: 'alert-title',
        positionClass: 'toast-top-center',
        toastClass: 'ngx-toastr alert alert-dismissible alert-notify toast-exporting',
      }
    );
  }

  downloadComplete(message: string, title: string = 'Download Complete!') {
    this.toastr.show(
      `<div class="alert-content">
        <span class="alert-icon" data-notify="icon">
          <img src="assets/img/icons/common/check-mark-icon.svg" class="toast-check-img" />
        </span>
        <div class="alert-text">
          <span class="alert-title" data-notify="title">${title}</span>
          <span data-notify="message">${message}</span>
        </div>
      </div>`,
      '',
      {
        timeOut: 6000,
        closeButton: true,
        enableHtml: true,
        tapToDismiss: false,
        titleClass: 'alert-title',
        positionClass: 'toast-top-center',
        toastClass: 'ngx-toastr alert alert-dismissible alert-notify toast-download-complete',
      }
    );
  }

  neutralInfo(message: string, title: string = 'Success', iconUrl: string = 'assets/img/icons/common/info-icon.svg') {
    this.toastr.show(
      `<div class="alert-content">
        <span class="alert-icon" data-notify="icon">
          <img src="${iconUrl}" class="toast-info-img" />
        </span>
        <div class="alert-text">
          <span class="alert-title" data-notify="title">${title}</span>
          <span data-notify="message">${message}</span>
        </div>
      </div>`,
      '',
      {
        timeOut: 6000,
        closeButton: true,
        enableHtml: true,
        tapToDismiss: false,
        titleClass: 'alert-title',
        positionClass: 'toast-top-center',
        toastClass: 'ngx-toastr alert alert-dismissible alert-notify toast-download-complete',
      }
    );
  }

  dismiss(toastRef: ActiveToast<any>): void {
    this.toastr.remove(toastRef.toastId);
  }
}